import { RadioGroup } from "ui-kit/components-branded/index"
import { PaymentMethod } from "modules/ClientAccount/utils"
import { Icon } from "components"
import { PaymentIcon } from "components/PaymentIcon"

interface Props {
    card: PaymentMethod
    onChange: (card: PaymentMethod) => void
    payExternalId: string | undefined
}

export function CardItem({ card, payExternalId, onChange }: Props) {
    return (
        <RadioGroup.Item
            onChange={() => onChange(card)}
            name="hide-profile-reason"
            className="is-fullwidth card-item-radio"
            value={card.external_id}
            checked={payExternalId === card.external_id}
        >
            <div className="card-item">
                <Icon type="four-dots-unselected" size="28" />
                <div className="card-item__last-card-digits">{card?.card_mask?.slice(-4)}</div>
                <PaymentIcon cardName={card?.card_type} />
            </div>
        </RadioGroup.Item>
    )
}
